import { useEffect, useState } from "react";
import { getGeoInfo } from "@/lib/geo";

// Wraps the storefront's children. If the visitor's IP resolves to mainland
// China (CN), renders a "not available in your region" screen instead.
// On any check failure, fades open (render children) to avoid false blocks.
export default function GeoGate({ children }) {
  const [status, setStatus] = useState("allowed"); // "allowed" | "blocked"

  useEffect(() => {
    let cancelled = false;
    // Cache the verdict for the session so we don't hit the backend (and the
    // rate-limited GeoIP service behind it) on every page load.
    let cached = null;
    try { cached = sessionStorage.getItem("geo_gate_v1"); } catch (_) { /* ignore */ }
    if (cached === "allowed") return;
    if (cached === "blocked") { setStatus("blocked"); return; }
    getGeoInfo()
      .then((data) => {
        if (cancelled) return;
        const blocked = !!(data && data.blocked);
        try { sessionStorage.setItem("geo_gate_v1", blocked ? "blocked" : "allowed"); } catch (_) { /* ignore */ }
        if (blocked) setStatus("blocked");
      })
      .catch(() => { /* fail open */ });
    return () => { cancelled = true; };
  }, []);

  if (status === "blocked") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-6" dir="ltr">
        <div className="max-w-md w-full text-center">
          <h1 className="text-3xl md:text-4xl font-black mb-4">Service Unavailable</h1>
          <p className="text-gray-300 mb-6">
            We're sorry — the LCTX online store is not available in your region.
            For inquiries, please contact us at hkjenholtd@gmail.com.
          </p>
          <a
            href="mailto:hkjenholtd@gmail.com"
            className="inline-block bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-lg font-semibold"
          >
            Contact Support
          </a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}